import { connect } from 'react-redux'
import { hasRoleInCompany } from '../../common/auth/authSelectors'
import { IGlobalState } from '../../Root/store/appReducer'
import { getCurrentCompanyGoal, getCurrentGoalActivityListClear } from './store/ActivityActions'
import { getUserGoals, getGoalsDtoLoading, getUserDto } from './store/ActivitySelectors'
import { Activity, IDispatchProps, IStateProps } from './Activity'
import { getUserCompanyCountries, getCompanyDivisions } from '../Settings/store/SettingsActions'
import { CompanyId, Role } from '../../services/api.types'

const mapStateToProps = (state: IGlobalState, ownProps: any): IStateProps => {
  return {
    hasRoleInCompany: (companyId: CompanyId, role: Role) => hasRoleInCompany(state, companyId, role),
    goalId: ownProps.match.params.goalId || null,
    token: ownProps.match.params.token || null,
    goals: getUserGoals(state),
    goalsDtoLoading: getGoalsDtoLoading(state),
    userDto: getUserDto(state),
  }
}

const mapDispatchToProps: IDispatchProps = {
  getUserCompanyCountries,
  getCompanyDivisions,
  getCurrentCompanyGoal,
  getCurrentGoalActivityListClear,
}

export default connect(mapStateToProps, mapDispatchToProps)(Activity)
